import React, { FC } from 'react'
import { ValidUntilP, ValidUntilTime } from './ValidUntil.style'
import { Trans } from 'react-i18next'

type Props = {
    endDate: string
    tKey: string
}

export const ValidUntil: FC<Props> = ({ endDate, tKey }) => (
    <ValidUntilP>
        <Trans
            i18nKey={tKey}
            components={{
                strong: <ValidUntilTime />
            }}
            values={{
                endDate
            }}
        />
    </ValidUntilP>
)
